import styled from 'styled-components';
import HappyCoupleFriendlySvg from './happyCoupleFriendlyv2.svg';

const HappyCoupleFriendlyIcon = styled(
  HappyCoupleFriendlySvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  margin: ${props => props.margin};
`;

export default HappyCoupleFriendlyIcon;
